import React, {Component} from "react";
import TreeSelectModal from "../../../../../components/treeSelectModal/TreeSelectModal";
import BaseComponent from "../../../../../base/BaseComponent";
import {filterForEach, generateTreeData} from "../../../../../utils";
import {treeForEach} from "../../../../../utils";
import {Icon} from "antd";

export default class MenuTreeSelectModal extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            treeData: [],
            expandedKeys: [],
            autoExpandParent: true,
            checkedKeys: {}
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.value !== this.props.value || prevProps.flag !== this.props.flag) {
            this.setTreeData();
        }
    }

    componentDidMount() {
        this.setTreeData();
    }

    render() {
        let {
            value,
            multiple,
            checkStrictly,
            onItemDelete,
            placeholder
        } = this.props;
        const {
            treeData,
            expandedKeys,
            autoExpandParent,
            checkedKeys
        } = this.state;

        let valueList = [];
        treeForEach(treeData, node => {
            if (node.id === value) {
                valueList.push({
                    label: node.title,
                    value: node.id
                });
            }
        });

        return treeData.length ? <TreeSelectModal
            title="选择上级菜单"
            treeData={treeData}
            valueList={valueList}
            expandedKeys={expandedKeys}
            autoExpandParent={autoExpandParent}
            checkedKeys={checkedKeys}
            showIcon={true}
            checkStrictly={checkStrictly}
            value={value}
            checkable={true}
            onCheck={this.onCheck}
            handleOk={this.handleOk}
            onExpand={this.onExpand}
            multiple={multiple}
            showModalHandle={this.showModalHandle}
            onItemDelete={onItemDelete}
            placeholder={placeholder}
        /> : null;
    }

    onCheck = c => {
        // 当不关联 单选的时候 特殊处理
        const {checkStrictly, multiple} = this.props;
        if (checkStrictly && !multiple) {
            while (c.checked.length > 1) {
                c.checked.shift();
            }
        }
        this.setState({
            checkedKeys: c
        });
    };

    handleOk = () => {
        const {checkedKeys} = this.state;
        const {checkStrictly} = this.props;
        if (checkStrictly) {
            this.props.onChange(checkedKeys.checked[0]);
        } else {
            this.props.onChange(checkedKeys);
        }
    };

    showModalHandle = () => {
        const {value, checkStrictly, multiple} = this.props;
        let checkedKeys = [];
        if (checkStrictly) {
            if (multiple) {
                checkedKeys = {checked: value};
            } else {
                checkedKeys = {checked: [value]};
            }
        } else {
            checkedKeys = value;
        }
        this.setState({
            checkedKeys
        });
    };

    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false
        });
    };

    // 获取树数据
    setTreeData = () => {
        const {currentId} = this.props;
        const treeDataIndex = {
            id: "id",
            title: "menuName",
            children: "child",
            key: "id"
        };
        this.findMenuTreeRequest(res => {
            let treeData = generateTreeData([res], treeDataIndex);
            const expandedKeys = [];
            treeForEach(treeData, node => {
                if (node.id === currentId) {
                    node.children = null;
                }
                if (node.children && node.children.length) {
                    expandedKeys.push(node.id);
                }
            });

            treeData = filterForEach(treeData, node => {
                return node.id !== currentId;
            });
            this.onExpand(expandedKeys);
            this.setState({
                treeData
            });
        });

    };

    // 获取树数据
    findMenuTreeRequest = callBack => {
        this.request({
            url: "/cm-sites-sys/menu/findMenuTree",
            callBack
        });
    };

}

